var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65698 5.81825H28.3425C27.4307 4.71418 26.3732 3.73512 25.2002 2.90918H6.79929C5.62623 3.73499 4.56879 4.71412 3.65698 5.81825V5.81825Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 16.4904 0.0233125 16.9753 0.0665 17.4545H31.9335C31.9767 16.9753 32 16.4904 32 16C32 15.5095 31.9767 15.0247 31.9335 14.5455H0.0665C0.0233125 15.0247 0 15.5095 0 16H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74455 23.2727H30.255C30.7262 22.3511 31.1104 21.3779 31.3973 20.3637H0.602295C0.889107 21.3779 1.27348 22.3511 1.74455 23.2727V23.2727Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79929 29.0909H25.2001C26.3732 28.2649 27.4307 27.2859 28.3424 26.1818H3.65698C4.56879 27.2858 5.62623 28.2649 6.79929 29.0909V29.0909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602295 11.6364H31.3974C31.1105 10.6221 30.7262 9.64886 30.2551 8.72729H1.74461C1.27355 9.64886 0.88917 10.6221 0.602295 11.6364V11.6364Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 2.90906H25.2006C22.5981 1.07669 19.425 0 16.0002 0C13.9132 0 10.2548 1.07669 7.65234 2.90906Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 8.72731H30.2551C29.723 7.68649 29.0804 6.71155 28.3426 5.81824H15.3042V8.72731Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 14.5455H31.9333C31.8433 13.5467 31.6624 12.5739 31.3974 11.6365H15.3042V14.5455Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.60265 20.3637H31.3976C31.6628 19.4263 31.8436 18.4535 31.9336 17.4546H0.0666504C0.15665 18.4535 0.337525 19.4262 0.60265 20.3637V20.3637Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65737 26.1818H28.3429C29.0807 25.2883 29.7233 24.3135 30.2554 23.2727H1.74487C2.27694 24.3135 2.91956 25.2885 3.65737 26.1818V26.1818Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.0001C19.4251 32.0001 22.5982 30.9234 25.2007 29.091H6.7998C9.4023 30.9234 12.5754 32.0001 16.0002 32.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602588 11.6364C0.337463 12.5739 0.15665 13.5466 0.0666504 14.5454H16.0001V0C8.6764 0 2.50209 4.92075 0.602588 11.6364V11.6364Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52419 4.17395L10.5601 7.36239H13.913L11.2006 9.33314L12.2365 12.5218L9.52419 10.5511L6.81175 12.5218L7.84787 9.33314L5.1355 7.36239H8.48819L9.52419 4.17395Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberia);
export default __webpack_public_path__ + "static/media/liberia.570f1483.svg";
export { ForwardRef as ReactComponent };